// Vendors
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Component
import InvoiceForm from './InvoiceForm';

// Actions
import { storageUserData } from '../../ReduxConfig/checkout';
import { toggleTacModal } from '../../Features/common';

// Constants
import { selector } from './InvoiceForm.selector';

const ConnectedInvoiceForm = props => {
  const state = useSelector(selector);
  const dispatch = useDispatch();
  const actions = {
    setUserData: data => dispatch(storageUserData(data)),
    toggleTacModal: () => dispatch(toggleTacModal())
  };

  return <InvoiceForm actions={actions} {...props} {...state} />;
};

export default ConnectedInvoiceForm;
